// extracted by mini-css-extract-plugin
export default {"title":"DevelopArea_title__K1Rtd"};